import { useStore } from '@nanostores/preact'
import { profile, support } from '../services/store'
import { Currency, IsoCountry, Products } from '../services/support'

export function useUserData() {
  const user = useStore(profile)
  const supportData = useStore(support)

  if (!supportData) return { country: null, currency: null, products: null }

  const country: IsoCountry | undefined = supportData.iso_countries.find(
    (c) => c.iso === user.countryIso
  )
  const currency: Currency | undefined = country
    ? supportData.currencies.find((c) => c.acronym === country.currency)
    : undefined
  const { products }: { products: Products } = supportData

  return { country, currency, products }
}
